module.exports = __webpack_public_path__ + "assets/img/102.3f91a471.png";